module.exports = __webpack_public_path__ + "img/download-center.71088e7b.png";